import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const AirlinesBlock = () => {
  return (
    <>
      <Box className="headingBtnWrap">
        <Typography variant="h1">Airlines Block</Typography>
      </Box>
    </>
  )
}

export default AirlinesBlock
